import Axios from 'axios';
import { stringify } from 'qs';

export default Axios.create({
    withCredentials: true,
    transformRequest: [
        function(data, headers) {
            headers['X-CSRF-Token'] = document.head.querySelector('meta[name="csrf-token"]').content || '';

            if (data instanceof FormData) {
                return data;
            }

            return stringify(data);
        },
    ],
});
